import {
  getTokenMsgArr
} from '@/assets/js/api.js';
export default {
  data() {
    return {
      isShow: false,
      isLoading: false,
      tokenList: [],
      tableList: [],
      coinSelect: '',
      coinSelectIndex: '',
      coinName: [],
      total: 0,
      page: 1,
      pagesize: 10,
      hiddenIcon: (process.env.VUE_APP_TOKEN_HIDDEN_ICON === 'true'),
      hiddenDesc: (process.env.VUE_APP_TOKEN_HIDDEN_DESC === 'true'),
      coin: require('../../assets/images/img/coin.png')
    }
  },
  mounted: function () {
    this.SuccessToken();
  },
  methods: {
    //获取所有创建成功的token
    SuccessToken() {
      this.isLoading = true
      let tokenArr = []
      let hiddenArr = []
      this.$chain33Rpc.queryAllTokens().then((data) => {
        // 无token
        if (!data.result) {
          this.isShow = true
          this.isLoading = false
          return
        }
        this.tokenList = data.result.tokens
        // 隐藏无icon的token->请求全部token的icon，否则分页请求token
        if (this.hiddenIcon) {
          this.tableList = this.tokenList
        } else {
          this.tableList = this.tokenList.slice((this.page - 1) * this.pagesize, this.page * this.pagesize)
        }
        this.tableList.map((current, index) => {
          tokenArr.splice(index, 1, current.symbol)
        })
        getTokenMsgArr(tokenArr).then((data) => {
          if (data.code === 0) {
            data.data.map((current) => {
              for (var i = 0; i < tokenArr.length; i++) {
                if (current.name === tokenArr[i]) {
                  this.tableList[i].icon = current.icon
                  this.tableList[i].introduce = current.introduce === null ? current.introduction : JSON.parse(current.introduce)['zh-CN']
                  this.tableList[i].nickname = JSON.parse(current.nickname)['zh-CN'] === null ? '' : JSON.parse(current.nickname)['zh-CN']
                }
              }
            })
            this.total = this.tokenList.length
            if (this.hiddenIcon) {
              this.tableList.map((current) => {
                if (current.icon !== '' && current.icon !== undefined && current.icon !== null) {
                  hiddenArr.push(current)
                }
              })
              this.tableList = hiddenArr
              this.total = this.tableList.length
            }
          }
          this.isLoading = false
        }).then(() => {
          //检索tokenName过滤
          if (!this.hiddenIcon) {
            this.tokenList.map((current, index) => {
              this.coinName[index] = {
                'value': current.symbol,
                'index': index
              }
            })
          } else {
            this.tableList.map((current, index) => {
              this.coinName[index] = {
                'value': current.symbol,
                'index': index
              }
            })
          }
        })
      })
    },
    //token搜索列表
    querySearch(queryString, cb) {
      var coinName = this.coinName;
      console.log(coinName)
      var results = queryString ? coinName.filter(this.createFilter(queryString)) : coinName;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    //搜索token
    searchToken(token) {
      let tokenExsit = false
      this.coinName.findIndex((val) => {
        if (!tokenExsit) {
          if (val.value === token) {
            tokenExsit = true
          } else {
            tokenExsit = false
          }
        }
      })
      if (tokenExsit) {
        this.$router.push({
          path: '/tokenDetail',
          query: {
            TokenName: token
          }
        })
      } else {
        this.$notify({
          title: '提示',
          message: '没有此Token',
          type: 'warning'
        })
      }
    },
    //分页
    handleCurrentChange(val) {
      this.page = val
      if (this.hiddenIcon) {
        return
      } else {
        this.isLoading = true
        this.tableList = []
        let symbolArr = []
        this.tableList = this.tokenList.slice((this.page - 1) * this.pagesize, this.page * this.pagesize)
        this.tableList.map((current, index) => {
          symbolArr.splice(index, 1, current.symbol)
        })
        getTokenMsgArr(symbolArr).then((data) => {
          if (data.code === 0) {
            data.data.map((current) => {
              for (var i = 0; i < symbolArr.length; i++) {
                if (current.name === symbolArr[i]) {
                  this.tableList[i].icon = current.icon
                  this.tableList[i].introduce = current.introduce === null ? current.introduction : JSON.parse(current.introduce)['zh-CN']
                  this.tableList[i].nickname = JSON.parse(current.nickname) === null ? '' : JSON.parse(current.nickname)['zh-CN']
                }
              }
            })
          }
          this.isLoading = false
        })
      }
    }
  },
}